export default __webpack_public_path__ + "static/media/scratch4.3b54d34f.mp3";